var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M9 2v14M16 9l-7 7-7-7"})));
}

ArrowDown.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
